export const isObjectIdRegex = /^[0-9a-fA-F]{24}$/
